export const COMPETITION_ID = "-Ovny1JYugr3tbmMJB4L";
